import React from 'react';
import step_one from './../../../image/trial_email_step_1.png';
import step_one_manual from './../../../image/email_with_message_manual_flow.png';
import step_two from './../../../image/trial_email_step_2.png';
import step_three from './../../../image/trial_activate_step_3.png';
import green_check from './../../../image/Icons/green-check.png';

export default class OrderSteps extends React.Component {
  render() {
    return (
      <div className='col-sm-12'>
        <div className='trial-header'>
          <span>
            <img src={green_check} alt='Success' />
          </span>
          <div className='heading1 padding-10 order-h3'>
            Order #
            {this.props.order && Object.keys(this.props.order).length > 0
              ? this.props.order.orderNumber
              : this.props.paidOrder.orderNumber}{' '}
            request received
          </div>
          {(this.props.isManualPaid || this.props.isAutoPaid) && (
            <p>Thank you for your order. We have just sent you an email confirming this request.</p>
          )}
          {this.props.isInvestorTrial && (
            <p>
              Thank you for your interest in a Cotality product trial. We have just sent you an
              email confirming your trial request.
            </p>
          )}
        </div>
        <div className='heading2 padding-30-0-10 step-header order-h6'>Next Steps</div>
        <div className='success-page-row'>
          <div className='success-page-column'>
            <span className='step-title order-h4'>Step 1</span>
            {this.props.isManualPaid && (
              <>
                <img src={step_one_manual} className='trial-image' alt='Step 1 Manual' />
                <p className='step-instructions order-h4'>
                  1. Open the “Welcome to RP Data” invite email
                </p>
                <p className='step-instructions-sub body'>
                  We will get this to you as soon as possible.
                </p>
              </>
            )}
            {(this.props.isAutoPaid || this.props.isInvestorTrial) && (
              <>
                <img src={step_one} className='trial-image' alt='Step 1' />
                <p className='step-instructions order-h4'>
                  1. Open the “Welcome to RP Data” invite email
                </p>
                <p className='step-instructions-sub body'>
                  We plan to get it to you within 5 minutes but on occasions it may take several
                  hours.
                </p>
              </>
            )}
          </div>

          <div className='success-page-column'>
            <span className='step-title order-h4'>Step 2</span>
            <img src={step_two} className='trial-image' alt='Step 2' />
            <p className='step-instructions order-h4'>
              2. Click this link to activate your RPP username
            </p>
          </div>

          <div className='success-page-column'>
            <span className='step-title order-h4'>Step 3</span>
            <img src={step_three} className='trial-image' alt='Step 3' />
            <p className='step-instructions order-h4'>
              3. Select ‘Yes’ and enter the username, email and password you just used on our online
              store
            </p>
          </div>
        </div>
        <hr />
        <div className='padding-10 body-semibold'>
          From there just follow the on-screen prompts to start using RP Data.
        </div>
        <hr />
        <p className='footnote-text'>
          If you have any questions, please contact our Customer Care team on <b>1300 734 318</b>{' '}
          and refer to order #
          {this.props.order && Object.keys(this.props.order).length > 0
            ? this.props.order.orderNumber
            : this.props.paidOrder.orderNumber}
          .
        </p>
        <p>
          You may now close this window or return to{' '}
          <a
            className='dark-azure-link'
            onClick={() => {
              this.props.redirectToURL('https://cotality.com/au');
            }}
          >
            cotality.com/au
          </a>
        </p>
      </div>
    );
  }
}
